export const USER_AUTHENTICATED = 'onboarding/USER_AUTHENTICATED';
export const CALENDAR_ADDED = 'onboarding/CALENDAR_ADDED';

export const VALUE_SET = 'onboarding/VALUE_SET';
export const NEXT = 'onboarding/NEXT';
export const PREV = 'onboarding/PREV';

export const SUBSCRIPTION_STARTED = 'onboarding/SUBSCRIPTION_STARTED';
